import { useEffect, useMemo, useState } from "react";

export interface PaginationState<T> {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  pagedItems: T[];
  setPage: (page: number) => void;
}

/**
 * 通用分页：传入完整列表，返回当前页数据。
 * resetKey 变化时（例如搜索词、筛选条件改变）会自动回到第一页。
 */
export function usePagination<T>(items: T[], pageSize: number, resetKey?: unknown): PaginationState<T> {
  const [page, setPage] = useState(1);
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const pagedItems = useMemo(
    () => items.slice((page - 1) * pageSize, page * pageSize),
    [items, page, pageSize],
  );

  return { page, pageSize, total, totalPages, pagedItems, setPage };
}